import React, { useEffect, useState } from "react";
import moment from "moment";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

const disabledDate = (current) => {
  return (
    current.isBefore(moment().subtract(365, "day")) ||
    current > moment().endOf("day")
  );
};

function DateFilter({ setDefaultDate, setCurrent }) {
  const handleDate = (value, dateString) => {
    setCurrent(1);
    if (value === null) {
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      setDefaultDate(dateString);
    }
  };

  return (
    <div className="cursor-pointer">
      <RangePicker
        format="YYYY-MM-DD"
        onChange={handleDate}
        //   onOk={onOk}
        disabledDate={disabledDate}
        placeholder={[
          moment(new Date()).format("YYYY-MM-DD"),
          moment(new Date()).format("YYYY-MM-DD"),
        ]}
      />
    </div>
  );
}

export default DateFilter;
